export enum TipoEstudioEnum {
    BRAND_PENETRATION, PURCHASE_INTENTION, SHARE_WALLET, BRAND_LIFT, BRAND_POSITIONING, CONTENT_PERCEPTION,
    CONSUMER_CONFIDENCE, TRUST_IN_GOVERNMENT, IMAGE_PUBLIC_FIGURES, BRAND_AWARENESS, OMNICHANNEL, NPS,
    ADS_CREATIVE_ANALYSIS, AD_HOC, SPOT_COMERCIAL_SONY
}

const tipoEstudioIds = new Map<TipoEstudioEnum, string>();
tipoEstudioIds.set(TipoEstudioEnum.BRAND_PENETRATION, "BRAND_PENETRATION");
tipoEstudioIds.set(TipoEstudioEnum.PURCHASE_INTENTION, "PURCHASE_INTENTION");
tipoEstudioIds.set(TipoEstudioEnum.SHARE_WALLET, "SHARE_WALLET");
tipoEstudioIds.set(TipoEstudioEnum.BRAND_LIFT, "BRAND_LIFT");
tipoEstudioIds.set(TipoEstudioEnum.BRAND_POSITIONING, "BRAND_POSITIONING");
tipoEstudioIds.set(TipoEstudioEnum.CONTENT_PERCEPTION, "CONTENT_PERCEPTION");
tipoEstudioIds.set(TipoEstudioEnum.CONSUMER_CONFIDENCE, "CONSUMER_CONFIDENCE");
tipoEstudioIds.set(TipoEstudioEnum.TRUST_IN_GOVERNMENT, "TRUST_IN_GOVERNMENT");
tipoEstudioIds.set(TipoEstudioEnum.IMAGE_PUBLIC_FIGURES, "IMAGE_PUBLIC_FIGURES");
tipoEstudioIds.set(TipoEstudioEnum.BRAND_AWARENESS, "BRAND_AWARENESS");
tipoEstudioIds.set(TipoEstudioEnum.OMNICHANNEL, "OMNICHANNEL");
tipoEstudioIds.set(TipoEstudioEnum.NPS, "NPS");
tipoEstudioIds.set(TipoEstudioEnum.ADS_CREATIVE_ANALYSIS, "ADS_CREATIVE_ANALYSIS");
tipoEstudioIds.set(TipoEstudioEnum.AD_HOC, "AD_HOC");
tipoEstudioIds.set(TipoEstudioEnum.SPOT_COMERCIAL_SONY, "SPOT_COMERCIAL_SONY");

const tipoEstudioNombres = new Map<TipoEstudioEnum, string>();
tipoEstudioNombres.set(TipoEstudioEnum.BRAND_PENETRATION, "Category and brand penetration");
tipoEstudioNombres.set(TipoEstudioEnum.PURCHASE_INTENTION, "Purchase intention");
tipoEstudioNombres.set(TipoEstudioEnum.SHARE_WALLET, "Share of wallet");
tipoEstudioNombres.set(TipoEstudioEnum.BRAND_LIFT, "Brand lift");
tipoEstudioNombres.set(TipoEstudioEnum.BRAND_POSITIONING, "Brand positioning");
tipoEstudioNombres.set(TipoEstudioEnum.CONTENT_PERCEPTION, "Content perception");
tipoEstudioNombres.set(TipoEstudioEnum.CONSUMER_CONFIDENCE, "Consumer confidence");
tipoEstudioNombres.set(TipoEstudioEnum.TRUST_IN_GOVERNMENT, "Trust in Government");
tipoEstudioNombres.set(TipoEstudioEnum.IMAGE_PUBLIC_FIGURES, "Image of public figures");
tipoEstudioNombres.set(TipoEstudioEnum.BRAND_AWARENESS, "Brand Awareness");
tipoEstudioNombres.set(TipoEstudioEnum.OMNICHANNEL, "Omnichannel");
tipoEstudioNombres.set(TipoEstudioEnum.NPS, "NPS");
tipoEstudioNombres.set(TipoEstudioEnum.ADS_CREATIVE_ANALYSIS, "Ads Creative Analysis");
tipoEstudioNombres.set(TipoEstudioEnum.AD_HOC, "Request Ad-Hoc project");
tipoEstudioNombres.set(TipoEstudioEnum.SPOT_COMERCIAL_SONY, "Spot Comercial Sony");

export const obtenerNombreTipoEstudio = (tipo: TipoEstudioEnum) => tipoEstudioNombres.get(tipo) ?? "";
export const obtenerIdTipoEstudio = (tipo: TipoEstudioEnum) => tipoEstudioIds.get(tipo) ?? "";

export const obtenerNombresTipoEstudio =
    (): Array<[TipoEstudioEnum, string]> => Array.from(tipoEstudioNombres.entries());
export const obtenerIdsTipoEstudio =
    (): Array<[TipoEstudioEnum, string]> => Array.from(tipoEstudioIds.entries());
